import { Input, Select } from 'antd';
import React from 'react';
import { ExpandSVG, SearchSVG } from '../../../common/components/icons/SVGIcon';

const {Search} = Input;
const {Option} = Select;

const CallbackFilters = ({}) => {
  return (
    <div className="filterContainer">
      <div className="searchFieldContainer">
        <div className="searchField">
          <Search
            placeholder="Search Patient"
            onSearch={(value) => console.log(value)}
            style={{width: '100%'}}
            suffix={<SearchSVG />}
          />
        </div>
      </div>

      <div className="statusFilterContainer">
        <div className="statusFilter">
          <Select
            placeholder="Filter by Date Last Seen..."
            suffixIcon={<ExpandSVG />}
            allowClear={true}
          >
            <Option value="age1">Date 1</Option>
            <Option value="age2">Date 2</Option>
          </Select>
        </div>
      </div>
    </div>
  );
};

export default CallbackFilters;
